<!--  -->
<template>
  <div class='container'>
    <div class="home" v-show="type==1">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">平台公告</div>
          </div>
          <div class="flexrbc">
            <Input v-model="searchText" placeholder="请输入您要搜索的内容" style="width: auto" @on-blur="getList(1)" @on-enter="getList(1)">
            <Icon type="ios-search" slot="suffix" />
            </Input>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content-item" v-if="list.length!=0">
          <div class="noticeList">
            <div class="list-item flexrbc" v-for="(item,index) in list" :key="index">
              <div class="flexc0s">
                <div class="title">{{item.title}}</div>
                <div class="subtitle">{{item.count}}</div>
              </div>
              <div class="flexr0c">
                <div class="time">{{item.addTime}}</div>
                <div class="look-detail" @click="lookDetail(item.id)" :data-id="item.id">查看详情</div>
              </div>
            </div>
          </div>
          <div style="float: right;margin-bottom:20px">
            <Page :total="total" @on-change="changePage" show-total show-elevator />
          </div>
        </div>
        <div class="no-data-box flexccc" v-if="list.length==0">
          <img src="../../assets/imgs/home/no-data.png" alt="">
          <div class="no-data-txt">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="second-page" v-if="type==2">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="">
        <div class="title" @click="manage">平台公告</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="">
        <div class="title">公告详情</div>
      </div>
      <div class="detail-content flexc0c">
        <div class="title">{{detail.title}}</div>
        <div class="time">通知日期：{{detail.addTime}}</div>
        <div class="content-txt" v-html="detail.content"></div>
      </div>
      <div class="flexrbc bottom">
        <div v-if="last" class="pre-title flexr0c">上一篇：<div>{{lastTitle}}</div>
        </div>
        <div v-else></div>
        <div v-if="next" class="next-title flexr0c">下一篇：<div>{{nextTitle}}</div>
        </div>
        <div v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "announcement",
  components: {},
  data () {
    return {
      type: 1,
      model1: false,
      model2: false,
      searchText: "",
      pageSize: 10,
      total: 0,
      last: true,
      next: true,
      lastTitle: '',
      nextTitle: '',
      list: [],
      detail: {
        title: "",
        content: ""
      },
    };
  },
  methods: {
    manage () {
      this.type = 1
    },
    changePage (page) {
      this.getList(page)
    },
    lookDetail (id) {
      this.type = 2
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "ZexuaKyTMVe6TNdP3zwgbI6JARSOIo6M",
        id: id
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.detail = res.data.notice
          if (res.data.notice.last) {
            this.getLastTitle(this.detail.last)
            this.last = true
          } else {
            this.last = false
          }
          if (res.data.notice.next) {
            this.getNextTitle(this.detail.next)
            this.next = true
          } else {
            this.next = false
          }
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getLastTitle (id) {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "ZexuaKyTMVe6TNdP3zwgbI6JARSOIo6M",
        id: id
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.lastTitle = res.data.notice.title
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getNextTitle (id) {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "ZexuaKyTMVe6TNdP3zwgbI6JARSOIo6M",
        id: id
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.nextTitle = res.data.notice.title
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getList (index) {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "khjJY6fw5yCTRS9K3HwV1ow5gRyIH4mI",
        pageIndex: index,
        pageSize: this.pageSize
      };
      this.searchText ? data.keyword = this.searchText : data
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.list = res.data.list
          this.total = res.data.count
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
  },
  created () {
    this.getList(1)
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  height: 100%;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #fff;

  .home {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      /deep/.ivu-input-with-suffix {
        border-radius: 15px;
      }

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        width: 80px;
        height: 30px;
        background-image: linear-gradient(180deg, #f5515f 0%, #9f041b 100%);
        border: 1px solid #d0021b;
        border-radius: 6px;
        cursor: pointer;
        margin-left: 30px;

        &:hover {
          background-image: linear-gradient(180deg, #ff7d89 0%, #b4051f 100%);
          border: 1px solid #af1228;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }
    }

    .content {
      background: #fff;
      // min-height: 775px;
      width: 100%;
      // box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
      border-radius: 0 0 10px 10px;

      .content-item {
        width: 928px;
        margin: 0 auto;

        .noticeList {
          margin-bottom: 20px;

          .list-item {
            width: 928px;
            height: 100px;
            background: rgba(224, 229, 240, 0.3);
            margin-top: 18px;
            box-sizing: border-box;
            padding: 0 26px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #4a4a4a;

            .title {
              font-family: PingFangSC-Medium;
              font-size: 16px;
              color: #4a4a4a;
              margin-bottom: 10px;
              font-weight: 600;
              width: 574px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: left;
            }

            .subtitle {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #4a4a4a;
              text-align: left;
              width: 574px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }

            .time {
              font-size: 14px;
              color: #4a4a4a;
            }

            .look-detail {
              margin-left: 44px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #616c84;
              cursor: pointer;

              &:hover {
                color: #2c59c3;
              }
            }
          }
        }
      }

      .no-data-box {
        background-color: #fff;
        height: 662px;
        width: 980px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0 0 10px 10px;

        img {
          width: 210px;
          height: 140px;
        }

        .no-data-txt {
          margin-top: 20px;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #9999a8;
          letter-spacing: 0.22px;
        }
      }
    }
  }

  .second-page {
    width: 980px;
    // height: 980px;
    min-height: 775px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;
    overflow: hidden;

    .top {
      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .detail-content {
      width: 860px;
      min-height: 775px;
      overflow: hidden;
      text-align: left;
      margin: 10px 52px;

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #252a37;
        letter-spacing: 0.36px;
        font-weight: bold;
        margin-bottom: 12px;
      }

      .time {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #9b9b9b;
        letter-spacing: 0.21px;
        margin-bottom: 16px;
      }

      .content-txt {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #252a37;
        letter-spacing: 0.25px;
        text-align: justify;
        line-height: 24px;
      }
    }

    .bottom {
      width: 928px;
      height: 20px;
      margin-left: 26px;
      margin-bottom: 50px;

      .pre-title,
      .next-title {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #9b9b9b;
        letter-spacing: 0.21px;
        text-align: justify;
        line-height: 22px;

        & > div {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // width: 180px;
          max-width: 180px;
        }
      }
    }
  }
}
</style>
